import axios from '../../Library/Axios';

const defaultUri = '/order/{orderId}/object/{objectId}/delivery';

/**
 * prepareUri()
 * @param orderId
 * @param objectId
 * @returns {string}
 */
function prepareUri(orderId, objectId) {
  return defaultUri.replace('{orderId}', orderId).replace('{objectId}', objectId);
}

export const DELIVERYREPORT_GETPDF_START = 'DELIVERYREPORT_GETPDF_START';
export const DELIVERYREPORT_GETPDF_SUCCESS = 'DELIVERYREPORT_GETPDF_SUCCESS';
export const DELIVERYREPORT_GETPDF_ERROR = 'DELIVERYREPORT_GETPDF_ERROR';

/**
 * getPdf()
 * @param orderId
 * @param objectId
 * @param deliveryReportId
 * @param withImages
 * @returns {function(*): *}
 */
export function getPdf(orderId, objectId, deliveryReportId, withImages = false) {
  return (dispatch) => {
    dispatch({ type: DELIVERYREPORT_GETPDF_START });

    const config = {
      params: { action: 'pdf', withImages },
      responseType: 'arraybuffer',
    };
    const preparedUri = prepareUri(orderId, objectId);
    const uri = `${preparedUri}/${deliveryReportId}`;

    return axios().get(uri, config).then((response) => {
      const { data } = response;
      const blobFile = new Blob(
        [data],
        { type: 'application/pdf' },
      );
      dispatch({ type: DELIVERYREPORT_GETPDF_SUCCESS, payload: data });
      return Promise.resolve(blobFile);
    }).catch((error) => {
      dispatch({ type: DELIVERYREPORT_GETPDF_ERROR, payload: error });
      return Promise.reject(error);
    });
  };
}

export const DELIVERYREPORT_DOWNLOADIMAGES_START = 'DELIVERYREPORT_DOWNLOADIMAGES_START';
export const DELIVERYREPORT_DOWNLOADIMAGES_SUCCESS = 'DELIVERYREPORT_DOWNLOADIMAGES_SUCCESS';
export const DELIVERYREPORT_DOWNLOADIMAGES_ERROR = 'DELIVERYREPORT_DOWNLOADIMAGES_ERROR';

/**
 * downloadImages()
 * @param orderId
 * @param objectId
 * @param deliveryReportId
 * @returns {function(*): Promise<Blob | never>}
 */
export function downloadImages(orderId, objectId, deliveryReportId) {
  return (dispatch) => {
    dispatch({ type: DELIVERYREPORT_DOWNLOADIMAGES_START });

    const config = {
      params: { action: 'downloadImages' },
      responseType: 'arraybuffer',
    };
    const preparedUri = prepareUri(orderId, objectId);
    const uri = `${preparedUri}/${deliveryReportId}`;

    return axios().get(uri, config).then((response) => {
      const { data } = response;
      const blobFile = new Blob(
        [data],
        { type: 'application/zip' },
      );
      dispatch({ type: DELIVERYREPORT_DOWNLOADIMAGES_SUCCESS, payload: data });
      return Promise.resolve(blobFile);
    }).catch((error) => {
      dispatch({ type: DELIVERYREPORT_DOWNLOADIMAGES_ERROR, payload: error });
      return Promise.reject(error);
    });
  };
}

export const DELIVERYREPORT_GETLIST_START = 'DELIVERYREPORT_GETLIST_START';
export const DELIVERYREPORT_GETLIST_SUCCESS = 'DELIVERYREPORT_GETLIST_SUCCESS';
export const DELIVERYREPORT_GETLIST_ERROR = 'DELIVERYREPORT_GETLIST_ERROR';

/**
 * getList()
 * @param orderId
 * @param objectId
 * @returns {function(*): Promise<Blob | never>}
 */
export function getList(orderId, objectId) {
  return (dispatch) => {
    dispatch({ type: DELIVERYREPORT_GETLIST_START });

    const uri = prepareUri(orderId, objectId);

    return axios().get(uri).then((response) => {
      const { status } = response;
      const { data } = response.data;

      if (status === 200) {
        dispatch({ type: DELIVERYREPORT_GETLIST_SUCCESS, payload: data });
        return Promise.resolve(data);
      }
      dispatch({ type: DELIVERYREPORT_GETLIST_ERROR });
      return Promise.resolve();
    }).catch((error) => {
      dispatch({ type: DELIVERYREPORT_GETLIST_ERROR, payload: error });
      return Promise.reject(error);
    });
  };
}

export const DELIVERYREPORT_GET_START = 'DELIVERYREPORT_GET_START';
export const DELIVERYREPORT_GET_SUCCESS = 'DELIVERYREPORT_GET_SUCCESS';
export const DELIVERYREPORT_GET_ERROR = 'DELIVERYREPORT_GET_ERROR';

/**
 * getList()
 * @param deliveryReportId
 * @returns {function(*): Promise<Blob | never>}
 */
export function get(deliveryReportId) {
  return (dispatch) => {
    dispatch({ type: DELIVERYREPORT_GET_START });

    // Just a hack. Notifications have only the reportID and nothing else so we send dummy values for order and object
    // We do not need the ids in the API Backend
    const uri = `${prepareUri(0, 0)}/${deliveryReportId}`;

    return axios().get(uri).then((response) => {
      const { status } = response;
      const { data } = response.data;

      if (status === 200) {
        dispatch({ type: DELIVERYREPORT_GET_SUCCESS, payload: data });
        return Promise.resolve(data);
      }
      dispatch({ type: DELIVERYREPORT_GET_ERROR });
      return Promise.resolve();
    }).catch((error) => {
      dispatch({ type: DELIVERYREPORT_GET_ERROR, payload: error });
      return Promise.reject(error);
    });
  };
}
